import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import capitalize from 'lodash/capitalize.js';
import { componentGenerator } from '@wix/gena';
import { getSiteWidgetExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const REACT_COMPONENT_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/react-component'
);

export async function generateReactComponent(
  projectFolder: string,
  route: string,
  name: string
) {
  const cwd = getSiteWidgetExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'tsx',
    });

  const config = {
    id: randomUUID(),
    name,
    type: capitalize(camelCase(route)),
    selector: `.${route}`,
    component: relativePathToCodeFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: REACT_COMPONENT_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      config,
    },
  });
}
